const LENGTH_OPTIONS = [
    { label: '1 month', value: 30 },
    { label: '2 months', value: 60 },
    { label: '3 months', value: 90 },
    { label: '4 months', value: 120 },
    { label: '5 months', value: 150 },
    { label: '6 months', value: 180 },
    { label: '7 months', value: 210 },
    { label: '8 months', value: 240 },
    { label: '9 months', value: 270 },
    { label: '10 months', value: 300 },
    { label: '11 months', value: 330 },
    { label: '12 months', value: 360 },
    { label: '13 months', value: 390 },
    { label: '14 months', value: 420 },
    { label: '15 months', value: 450 },
    { label: '16 months', value: 480 },
    { label: '17 months', value: 510 },
    { label: '18 months', value: 540 },
    { label: '19 months', value: 570 },
    { label: '20 months', value: 600 },
    { label: '21 months', value: 630 },
    { label: '22 months', value: 660 },
    { label: '23 months', value: 690 },
    { label: '24 months', value: 720 },
];

export default LENGTH_OPTIONS;